import { __generator } from "tslib";
import { all, put, select, takeEvery, call } from 'redux-saga/effects';
import { withCursor, selectors } from '../../Stream';
import { createCallbackActionCreator } from '../../Stream/helpers';
import { request } from '../../xhr';
import { initializeStreamAndFetchFirst, fetchNext, getStreamId, } from './actionCreators';
function handleInitializeStreamAndFetchFirst(action) {
    var deviationId, fetchNextCallback;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                deviationId = action.payload.deviationId;
                fetchNextCallback = createCallbackActionCreator(fetchNext.toString());
                return [4 /*yield*/, put(withCursor.actions.initialize({
                        streamId: getStreamId(deviationId),
                        itemsPerFetch: 25,
                        items: [],
                        hasMore: true,
                        cursor: undefined,
                        streamParams: {
                            deviationId: deviationId,
                        },
                        fetchNextCallback: fetchNextCallback,
                    }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleFetchNext(action) {
    var streamId, _a, cursor, limit, streamParams, params, result, results, nextCursor;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                streamId = action.payload.streamId;
                return [4 /*yield*/, select(function (state) { return ({
                        streamParams: selectors.getStreamParams(state, streamId),
                        cursor: withCursor.selectors.getCursor(state, streamId),
                        limit: selectors.getItemsPerFetch(state, streamId),
                    }); })];
            case 1:
                _a = _b.sent(), cursor = _a.cursor, limit = _a.limit, streamParams = _a.streamParams;
                params = {
                    deviationid: streamParams.deviationId,
                    cursor: cursor,
                    limit: limit,
                };
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: 'deviation/featured_in_groups',
                        params: params,
                    }, function () { })];
            case 2:
                result = _b.sent();
                if (!(result && !result.error)) return [3 /*break*/, 4];
                results = result.results, nextCursor = result.cursor;
                return [4 /*yield*/, put(withCursor.actions.fetchSuccessDeduped({
                        streamId: streamId,
                        hasMore: nextCursor !== undefined,
                        cursor: nextCursor,
                        items: results,
                    }))];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, put(withCursor.actions.fetchFailure({
                    streamId: streamId,
                    errorMsg: "Failed to fetch: ".concat(result === null || result === void 0 ? void 0 : result.error),
                }))];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
export default function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(initializeStreamAndFetchFirst, handleInitializeStreamAndFetchFirst),
                    takeEvery(fetchNext, handleFetchNext),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map